import { render, staticRenderFns } from "./TermsHistoryDetails.vue?vue&type=template&id=4f9c04ec&"
import script from "./TermsHistoryDetails.vue?vue&type=script&lang=ts&"
export * from "./TermsHistoryDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports